import { I18nManager } from 'react-native';

import I18n from 'i18n-js';
import {
  get as _get,
  isPlainObject as _isPlainObject,
  replace as _replace,
  merge as _merge,
} from 'lodash';

class ContentManager {
  constructor() {
    ContentManager.dynamicContent = {};

    this.setDefaultLocale('en');
  }

  get isRTL() {
    return I18nManager.isRTL;
  }

  setDefaultLocale = defaultLocale => {
    I18n.defaultLocale = defaultLocale;
  };

  setLocale = locale => {
    I18n.locale = locale;
  };

  l = I18n.l;

  configureI18nTranslations = (translation = {}) => {
    _merge(I18n.translations, translation);
  };

  setupContentTranslationObject = (dynamicContentValues = {}) => {
    if (!_isPlainObject(dynamicContentValues)) {
      throw new Error(
        `Invalid value passed, expected an plain object but received ${JSON.stringify(
          dynamicContentValues,
        )}`,
      );
    }

    ContentManager.dynamicContent = dynamicContentValues;
  };

  translate = (key, placeholdersValues = [], translationOptions = {}) => {
    const { placeHolderRegEx: _placeHolderRegEx } = translationOptions;

    const placeHolderRegEx = _placeHolderRegEx || /%[1-9][0-9]*\$s/g;
    let currentReplacementIndex = 0;

    const value = _get(
      ContentManager.dynamicContent,
      key,
      I18n.t(key, { defaultValue: key, ...translationOptions }),
    );

    const valueWithPlaceHolders = _replace(value, placeHolderRegEx, () => {
      const replaceValue = placeholdersValues[currentReplacementIndex] || '';
      currentReplacementIndex++;
      return replaceValue;
    });

    return valueWithPlaceHolders;
  };
}

export default ContentManager;
